<template>
  <modal-with-form
    obj-display-name="Site"
    :allow-delete="$store.state.user_roles && $store.state.user_roles.is_admin"
    :allow-save="$store.state.user_roles && $store.state.user_roles.is_admin"
    :can-submit="isValid"
    :class="stateVarName + '-modal'"
    :full-page="false"
    :id="id"
    :inputs="inputs"
    :object-data="objectData"
    :state-var-name="stateVarName"
    :value="isActive"
    @closed="isActive = false"
    @input="activeChanged($event)"
    @saved="saved($event)"
    @deleted="deleted($event)"
  >
    <site-form
      v-model="inputs"
      :parent="toFSRef(parent)"
      :id="id"
      @validates="validChanged($event)"
    ></site-form>
  </modal-with-form>
</template>

<script>
import SiteForm from "./SiteForm";
import ModalWithForm from "../generic/ModalWithForm";
import { getObjectInArrayById } from "../../../scripts/filterHelpers";

export default {
  name: "AddSiteModal",
  components: { SiteForm, ModalWithForm },
  computed: {
    objectData() {
      let self = this,
        parent = self.parent ? self.toFSRef(self.parent) : null;
      return this.id
        ? Object.assign(
            { parent: parent },
            getObjectInArrayById(this.$store.state.sites, this.id)
          )
        : { parent: parent };
    },
  },
  data() {
    let self = this,
      parent = self.parent ? self.toFSRef(self.parent) : null;
    return {
      inputs: this.id
        ? Object.assign(
            { parent: parent },
            getObjectInArrayById(this.$store.state.sites, this.id)
          )
        : { parent: parent },
      isValid: false,
      isActive: this.value,
    };
  },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    id: {
      type: String,
      required: false,
    },
    parent: {
      type: Object,
      required: false,
    },
    stateVarName: {
      type: String,
      default: "sites",
    },
  },
  methods: {
    validChanged(valid) {
      this.isValid = valid;
    },
    activeChanged(val) {
      this.$emit("input", this.isActive);
    },
    saved(val) {
      this.$emit("saved", val);
      if (!this.id) {
        this.inputs = {
          parent: this.toFSRef(this.parent, "subcustomers"),
        };
      }
    },
    deleted(val) {
      this.$emit("deleted", val);
    },
  },
  watch: {
    isActive: {
      handler(val) {
        this.activeChanged(val);
      },
    },
    value: {
      handler(val) {
        this.isActive = val;
      },
    },
  },
};
</script>

<style scoped></style>
